import { transparentize } from 'polished';
import styled, { css } from 'styled-components';

export const Container = styled.div`
${({ theme }) => css`
  height: 100%;
  min-height: 42rem;

  border-radius: 1.6rem;
  background: ${transparentize(0.05, theme.colors.background)};

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: 2rem;

  > div {
    margin-bottom: 1.6rem;
  }

  @media (max-width: 670px) {
    padding: 0.8rem;
    max-width: 95%;
    margin: 0 auto;
  }
`}
`;

export const GraphContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;
